import { useEffect, useState } from "react";

const useCopyToClipboard = (resetAfterMs) => {
  const [hasCopied, setHasCopied] = useState(false);

  useEffect(() => {
    if (!hasCopied) return undefined;

    const timeout = setTimeout(() => setHasCopied(false), resetAfterMs);
    return () => clearTimeout(timeout);
  }, [hasCopied, resetAfterMs]);

  const copy = (text) => navigator.clipboard?.writeText(text).then(() => setHasCopied(true));

  return [hasCopied, copy];
};

export default useCopyToClipboard;
